export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4622.a06ab7ba.jpg";